import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import secret from './Icons/secret-icon.svg';
import clock from './Icons/clock-icon.svg';
import question from './Icons/question.svg';
import './navbar.css';

const Navbar = ({ isPortrait }) => {
    const navigate = useNavigate();

    const animateAndNavigate = (e, destination) => {
        e.preventDefault();
        e.stopPropagation();
        setTimeout(() => {
            navigate(destination);
        }, 300);
    };

    return (
        <div className={`navbar ${isPortrait ? 'navbar' : 'navbar-landscape'}`}>
            <motion.div whileTap={{ scale: 0.6 }} transition={{ duration: 0.3 }} onClick={(e) => animateAndNavigate(e, '/')}>
                <img src={clock} className='icon' alt='Home' />
            </motion.div>
            <motion.div whileTap={{ scale: 0.6 }} transition={{ duration: 0.3 }} onClick={(e) => animateAndNavigate(e, '/p2')}>
                <img src={secret} className='icon' alt='Secret' />
            </motion.div>
            <motion.div whileTap={{ scale: 0.6 }} transition={{ duration: 0.3 }} onClick={(e) => animateAndNavigate(e, '/p3')}>
                <img src={question} className='icon' alt='FAQ' />
            </motion.div>
        </div>
    );
};

export default Navbar;